//REACT
import * as React from "react";
//MATERIAL UI COMPONENTS
import { withTheme, withStyles, Dialog, Button } from "@material-ui/core";
import PropTypes from "prop-types";
//STYLE
import "./regStyles.css";
//COMPONENTS
import globalContext from "../../context/globalContext";

class TutorialDialog extends React.Component {
  static contextType = globalContext;
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    // const { classes } = this.props;
    const {
      tutorialDialogState,
      user,
      successSnackbarState
    } = this.context.global.data;

    if (!user || successSnackbarState) {
      return null;
    }

    return (
      <>
        <Dialog
          open={tutorialDialogState}
          maxWidth={"xl"}
          fullWidth
          style={{ zIndex: 90002 }}
        >
          <div className="tutorialDialog_image_container">
            <img
              className="tutorialDialog_image"
              src={
                "https://ff-attribute-icons.s3.us-east-2.amazonaws.com/FF_Tutorial.gif"
              }
              alt={"Loading ..."}
            />
            {/* <video width="400" height="400" autoplay controls>
              <source src={"https://ff-attribute-icons.s3.us-east-2.amazonaws.com/FF_Tutorial.mp4"} type="video/mp4"/>
              <source src={"https://ff-attribute-icons.s3.us-east-2.amazonaws.com/FF_Tutorial.mp4"} type="video/ogg"/>
              Your browser does not support the video tag.
            </video> */}
          </div>
          <div className="tutorialDialog_button_container">
            <Button onClick={() => this.context.global.handleCloseTutorial()}>
              {/* {user.hideTutorial ? "Close" : "Start Shopping!"} */}
              Close
            </Button>
          </div>
        </Dialog>
      </>
    );
  }
}

TutorialDialog.propTypes = {
  classes: PropTypes.object.isRequired
};

const styles = theme => ({});

export default withTheme()(withStyles(styles)(TutorialDialog));
